import { createApplicationController } from 'ui-forms-embed-components-frame-container/controllers/Application';
(() => {
  createApplicationController().initHubspotForm();
})();